import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { NoCodeHeroSection } from "@/components/insights/no-code/NoCodeHeroSection";
import { NoCodeTakeaway } from "@/components/insights/no-code/NoCodeTakeaway";
import { NoCodeFounderQuote } from "@/components/insights/no-code/NoCodeFounderQuote";
import { NoCodeComparison } from "@/components/insights/no-code/NoCodeComparison";
import { NoCodeDecisionGuide } from "@/components/insights/no-code/NoCodeDecisionGuide";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { RelatedTools } from "@/components/RelatedTools";
import { TableOfContents } from "@/components/TableOfContents";

const NoCodeVsCode = () => {
  return (
    <>
      <InsightEngagementTracker slug="no-code-vs-code" title="No-Code vs Code" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Development" 
          currentPage="No-Code vs Code" 
        />
        <NoCodeHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <NoCodeTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <NoCodeFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <NoCodeComparison />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <NoCodeDecisionGuide />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="no-code-vs-code" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default NoCodeVsCode;
